module.exports = __webpack_public_path__ + "static/img/上海农村商业银行.2757393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/上海农村商业银行.png
// module id = xu0s
// module chunks = 18